import React from "react"
import { OldIconButton, OldButtonGroup } from "@kit/design/old-button"

const Alignment = ({ onChange, alignment, availableAlignments }) => {
  const alignmentDisabled = val => !availableAlignments.includes(val)

  return (
    <OldButtonGroup>
      <OldIconButton
        label="align left"
        type="button"
        icon="left-align"
        onClick={() => onChange({ name: "alignment", value: "left" })}
        active={alignment === "left"}
        disabled={alignmentDisabled("left")}
      />
      <OldIconButton
        label="align center"
        type="button"
        icon="center-align"
        onClick={() => onChange({ name: "alignment", value: "center" })}
        active={alignment === "center"}
        disabled={alignmentDisabled("center")}
      />
      <OldIconButton
        label="align right"
        type="button"
        icon="right-align"
        onClick={() => onChange({ name: "alignment", value: "right" })}
        active={alignment === "right"}
        disabled={alignmentDisabled("right")}
      />
    </OldButtonGroup>
  )
}

Alignment.defaultProps = {
  availableAlignments: ["left", "center", "right"]
}

export { Alignment }
